import type { IOrganizationDeactivatedNotificationData } from "@frontend-shared/types";
import { Ban } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IOrganizationDeactivatedCardProps {
  uuid: string;
  data: IOrganizationDeactivatedNotificationData;
  createdAt: string;
  isRead: boolean;
}

const OrganizationDeactivatedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
}: IOrganizationDeactivatedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="organization_deactivated"
      createdAt={createdAt}
      isRead={isRead}
      icon={<Ban className="h-5 w-5" />}
      body={t("type.organization_deactivated.body", {
        organizationName: data.organizationName,
        deactivatedByName: data.deactivatedByName,
      })}
    />
  );
};

export const OrganizationDeactivatedCard = memo(
  OrganizationDeactivatedCardComponent,
);
